module.exports = __webpack_public_path__ + "static/media/lock-off.b5b065f6.svg";